/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EntityPropertyChange { 
    id?: number;
    entityChangeId?: number;
    newValue?: string | null;
    originalValue?: string | null;
    propertyName?: string | null;
    propertyTypeFullName?: string | null;
    tenantId?: number | null;
    newValueHash?: string | null;
    originalValueHash?: string | null;
}

